import DropdownItem from "@/components/DropdownItem";
import Modal from "@/components/Modal";
import { useApp, useAppStore } from "@/store/app";
import { useReplicacheSongs } from "@/store/replicache";
import type { SongId } from "@/utils/types";
import { useParams, useRouter } from "next/navigation";
import { MdDelete } from "react-icons/md";
import shallow from "zustand/shallow";

export default function DeleteSong({
  onlyIcon = false,
}: {
  onlyIcon?: boolean;
}) {
  const { user } = useAppStore(({ user }) => ({ user }), shallow);
  const { songs } = useReplicacheSongs();
  const { songId } = useParams() as { songId: SongId };
  const song = songs[songId];
  const title = song?.title || "";
  const { songRemove } = useApp();
  const router = useRouter();

  const handleDelete = () => {
    //console.debug("onDelete", { song });
    if (!user) {
      router.push("/signin");
      return;
    }
    if (!song) {
      throw new Error("No Song");
    }
    songRemove(song);
    window.analyticsLogEvent("Deleted Song", { songId: song.id });
    router.push("/");
  };

  const modalId = "delete-song-modal";
  return (
    <>
      <label htmlFor={modalId} className="modal-button">
        {onlyIcon ? (
          <div className="btn btn-ghost btn-circle">
            <MdDelete className="text-2xl" />
          </div>
        ) : (
          <DropdownItem>
            <MdDelete className="text-2xl" />
            Delete
          </DropdownItem>
        )}
      </label>

      <Modal id={modalId}>
        <h3 className="font-bold text-lg">Delete Song</h3>
        <div className="divider" />
        <div>
          Delete “{title}” from your Songbook?“
          <div className="modal-action">
            <button
              type="button"
              className="btn btn-secondary text-base-100"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
